@import "../../../../globalStyles/commons";

:host {
  display: block;
  /**
   * @prop --goat-header-height: Height of the header. Defaults to 3rem.
   */
  --goat-header-height: 3rem;

  /**
   * @prop --goat-header-width: Width of the header. Defaults to 100%.
   */
  --goat-header-width: 100%;
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;

  .header-container {
    height: var(--goat-header-height);
    width: var(--goat-header-width);
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;

    .left-section {
      justify-self: flex-start;
    }

    .center-section {
      justify-self: center;
    }

    .right-section {
      justify-self: flex-end;
    }

    .section {
      display: flex;
      align-items: center;
      height: 100%;

      slot::slotted(*) {
        display: flex;
        align-items: center;
        height: 100%;
        color: var(--header-text-color);
      }
    }
  }

  &.three-column .header-container {
    grid-template-columns: 1fr auto 1fr;
  }

  &.two-column .header-container {
    grid-template-columns: auto 1fr;
  }


  &.float {
    .header-container {
      margin: v(--spacing-05);
      border-radius: v(--border-radius);
      border: 1px solid var(--layer-accent);
      box-shadow: v(--shadow-md);
      overflow: clip;
    }

    @each $color in [primary, secondary, success, info, warning, error,white, black, brand-primary, brand-secondary] {
      &#{'.color-' + $color} .header-container {
        background: v(--color-#{$color});
      }
    }
  }

  &:not(.float) {
    @each $color in
      [primary, secondary, success, info, warning, error, white, black, brand-primary, brand-secondary] {
      &#{'.color-' + $color} {
        background: v(--color-#{$color});
      }
    }
  }
}

:host([color-is="dark"]):host {
  --header-text-color: #{v(--color-white)};
}

:host([color-is="light"]):host {
  --header-text-color: #{v(--color-black)};
}
